<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-09-18 10:00:07
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-12-28 18:37:46
 * @FilePath: /chaoyongtuan/src/views/teamManage/delegationHead/delegationHead.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="delegation-head">
			<platform-tab @change="handleClick" :platformId="platformId"></platform-tab>
			<div class="flex flex-align-center mt-8" v-show="showPlatformContent">
				<el-button type="primary" v-auth="['delegationhead:addreauthorize']" @click="readdCommd(0)">新增团长</el-button>
				<div class="ml-12 font-h6-regular">{{ auth_num }}/{{ privilege_num }}</div>
			</div>
			<multi-table
				v-show="showPlatformContent"
				ref="multiTable"
				class="base-table"
				:page="pageInfo"
				:columns="columns"
				:list="list"
				@getSortList="sortHandle"
				v-loading="loading"
				@gePartnerList="tabGetList"
				:total="total"
			>
				<empty slot="empty"></empty>
			</multi-table>
			<!-- <BaseTable v-show="showPlatformContent" :columns="columns" :list="list" :sortChange="sortChange" v-loading="loading">
				<template v-slot:empty>
					<empty slot="empty"></empty>
				</template>
			</BaseTable>
			<yx-pagination
				v-show="showPlatformContent"
				:total="total"
				:current-page="pageInfo.page_index"
				:page-size="pageInfo.page_size"
				@size-change="sizeChange"
				@current-change="currentChange"
			></yx-pagination> -->

			<!--授权弹窗 / 抖音 / 快手-->
			<auth-alert-dialog @refresh="refreshList()" ref="authAlertDialog"></auth-alert-dialog>
		</Panel>
	</div>
</template>
<script>
import AuthAlertDialog from '@/modules/auth/alert';
import { columns } from './columns';
import {
	authorizeList,
	institutionSetDefault,
	closeAuthorize,
	delAuthorize,
	getSpInstitutionList,
	setSpDefaultInstitution,
	cancelSpAuthorize,
} from '@/api/teamManage';
import empty from '@/views/common/empty/index.vue';
import authMixin from '@/modules/auth/mixin.js';
import { mapGetters } from 'vuex';
import { platformMixin } from '@rd/rd-ui';
export default {
	components: {
		empty,
		AuthAlertDialog,
	},
	mixins: [authMixin, platformMixin],
	data() {
		return {
			columns,
			loading: false,
			list: [],
			privilege_num: 0, //团长说齐全权益数量
			auth_num: 0, // 已授权数量
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			total: 0,
			sortParams: {},
		};
	},
	computed: {
		...mapGetters(['canShowPlatformList']),
		addDisable({ privilege_num, auth_num }) {
			return +privilege_num === +auth_num;
		},
		// 当前平台ID在购买平台列表中可以展示平台相关页面内容
		showPlatformContent() {
			if (this.platformId == 0) {
				return true;
			}
			return this.canShowPlatformList.map(item => +item.value).includes(+this.platformId);
		},
	},
	methods: {
		handleClick(val) {
			this.platformId = val;
			this.refreshList();
		},
		tabGetList(obj) {
			const { page_size, page_index } = obj;
			this.pageInfo.page_size = page_size;
			this.pageInfo.page_index = page_index;
			this.getList();
		},
		/**
		 * 回调回来刷新页面
		 */
		refreshList() {
			this.pageInfo.page_index = 1;
			this.getList();
		},
		/**
		 * 团长授权列表
		 */
		async getList() {
			try {
				this.loading = true;
				let api = authorizeList;
				let params = {
					platformId: this.platformId,
					...this.pageInfo,
					...this.sortParams,
				};
				let auth_num = 'auth_num';
				let privilege_num = 'privilege_num';

				if (this.platformId == dataMap.PLATFORM_SP.value) {
					api = getSpInstitutionList;
					params = {
						'page-index': 1,
						'page-size': 20,
					};
					auth_num = 'authNum';
					privilege_num = 'initNum';
				}
				const res = await api(params);
				this.loading = false;
				let { code, data } = res;
				if (code !== 0) return;
				this.list = data.list.map(item => {
					// 授权状态:success授权成功，unbinding未授权, fail授权失败，delete已删除
					const authStatusTxtMap = {
						success: {
							text: '授权成功',
							status: 0,
						},
						unbinding: {
							text: '未授权',
							status: 2,
						},
						fail: {
							text: '授权失败',
							status: 1,
						},
						delete: {
							text: '已删除',
							status: 2,
						},
					};
					if (this.platformId == dataMap.PLATFORM_SP.value) {
						const temp = {
							institution_name: item.authShopName,
							authority_id: item.outerShopId,
							status: authStatusTxtMap[item.authStatus].status,
							status_txt: authStatusTxtMap[item.authStatus].text,
							product_num: item.productNum,
							add_time: this.$options.filters.formatDateTime(item.addTime),
							is_default: item.isDefault,
							institution_id: item.outerShopId,
							...item,
						};
						return {
							...temp,
							operations: this.getButtons(temp),
						};
					}
					return {
						...item,
						operations: this.getButtons(item),
					};
				});
				this.privilege_num = data[privilege_num];
				this.auth_num = data[auth_num];
				this.total = data.page.item_total;
			} finally {
				this.loading = false;
			}
		},
		/**
		 * 操作成功之后 刷新页面
		 */
		refreshgetList() {
			this.pageInfo.page_index = 1;
			this.getList();
		},
		/**
		 * 排序
		 */
		sortHandle(val) {
			this.sortParams.sortKey = val.prop;
			this.sortParams.sortType = val.order === 'ascending' ? 'SORT_ASC' : 'SORT_DESC';
			this.getList();
		},
		/**
		 * 处理操作的按钮
		 */
		getButtons(item) {
			const defaultcommander = {
				label: '设置默认团长',
				type: 'text',
				isShow: this.$auth.hasPermi('delegationhead:defaultcommander') && item.status === 0,
				disabled: item.status === 1 || item.is_default === 1,
				click: () => {
					this.institutionSwitch(item);
				},
			};
			const goAuth = {
				label: '去授权',
				type: 'text',
				isShow: this.$isSp() && this.$auth.hasPermi('delegationhead:addreauthorize') && item.status == 2,
				click: () => {
					this.readdCommd(1, item.institution_id);
				},
			};
			const reauthorize = {
				label: '重新授权',
				type: 'text',
				isShow: this.$auth.hasPermi('delegationhead:addreauthorize') && item.status === 1,
				click: () => {
					this.readdCommd(1, item.institution_id);
				},
			};
			const closeauthorize = {
				label: '取消授权',
				type: 'text',
				isShow: this.$auth.hasPermi('delegationhead:closeauthorize') && item.status === 0,
				click: () => {
					this.$modal({
						title: '取消授权',
						contentTitle: '提示：取消后需要重新进行授权',
						size: 'small',
					}).then(res => {
						if (res.key == 'confirm') {
							this.reDeleteAuthorize(item.institution_id, 1);
							res.done();
						} else {
							res.done();
						}
					});
				},
			};
			const delauthorize = {
				label: '删除授权',
				type: 'text',
				isShow: this.$auth.hasPermi('delegationhead:delauthorize') && item.status === 1 && this.$isPlatOr(this.platformId, ['Dy', 'Ks']),
				click: () => {
					this.$modal({
						title: '删除授权',
						contentTitle:
							'删除授权后将删除该团长下的所有活动商品和团长活动，保留已有订单但不再更新订单状态，保留已有订单的业绩归属，是否确认删除授权？',
						size: 'small',
					}).then(res => {
						if (res.key == 'confirm') {
							this.reDeleteAuthorize(item.institution_id, 2);
							res.done();
						} else {
							res.done();
						}
					});
				},
			};
			return [defaultcommander, goAuth, reauthorize, closeauthorize, delauthorize].filter(item => item.isShow);
		},
		/**
		 * 表格取消授权 、删除授权
		 */
		async reDeleteAuthorize(institutionId, type) {
			const { platformId } = this;
			const cancelApiMap = {
				[dataMap.PLATFORM_DY.value]: closeAuthorize,
				[dataMap.PLATFORM_KS.value]: closeAuthorize,
				[dataMap.PLATFORM_SP.value]: cancelSpAuthorize,
			};
			let apiMaps = new Map([
				[1, cancelApiMap[platformId]],
				[2, delAuthorize],
			]);
			const params = {
				institutionId,
				platformId,
			};
			let paramsMap = {
				[dataMap.PLATFORM_DY.value]: params,
				[dataMap.PLATFORM_KS.value]: params,
				[dataMap.PLATFORM_SP.value]: params,
			};
			if (type == 1) {
				paramsMap[dataMap.PLATFORM_SP.value] = {
					shopId: institutionId,
				};
			}
			const { code } = await apiMaps.get(type)(paramsMap[platformId]);
			if (code !== 0) return;
			this.refreshgetList();
		},
		/**
		 * 新增团长 重新授权
		 */
		async readdCommd(type, institutionId) {
			if (this.addDisable) {
				this.$message.error('您的团长账号最大授权数量已超过限制，请联系客服处理');
				return;
			}
			this.checkAuthAdd(this.platformId, type, institutionId);
		},
		/**
		 * 设为默认团长
		 */
		async institutionSwitch(item) {
			const { institution_id: institutionId } = item;
			let params = {
				institutionId,
				platformId: this.platformId,
			};
			if (this.$isSp()) {
				params = {
					shopId: institutionId,
				};
			}
			const mapApi = {
				[dataMap.PLATFORM_DY.value]: institutionSetDefault,
				[dataMap.PLATFORM_KS.value]: institutionSetDefault,
				[dataMap.PLATFORM_SP.value]: setSpDefaultInstitution,
			};
			const { code } = await mapApi[this.platformId](params);
			if (code !== 0) return;
			this.refreshgetList();
			this.$message.success('操作成功');
		},
	},
	created() {
		this.getList();
	},
};
</script>
<style lang="less" scoped></style>
